<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="py-20 bg-chsc-raw">
        <UiContainer max-width="max-w-3xl">
            <header class="insight-category-header">
                <img
                    :src="blok?.icon.filename"
                    :alt="blok?.icon.alt"
                >
                <StoryblokRichText :doc="blok?.header" />
            </header>
        </UiContainer>
        <UiContainer>
            <div class="grid grid-cols-2 gap-x-20 items-center max-[769px]:grid-cols-1 max-[769px]:gap-x-0 max-[769px]:gap-y-10">
                <div class="flex flex-col items-center justify-center">
                    <div class="font-londrina-solid fs-6xl text-chsc-indigo-500 text-center uppercase [&>h6]:fs-7xl [&>h5]:fs-8xl [&>h6>strong]:text-chsc-yellow">
                        <StoryblokRichText :doc="blok?.claim" />
                    </div>
                    <img
                        v-motion-slide-visible-once-top
                        :src="blok?.image.filename"
                        :alt="blok?.image.alt"
                        class="-mt-10 max-[769px]:hidden"
                    >
                </div>
                <div class="insighr-category-description">
                    <StoryblokRichText :doc="blok?.description" />
                </div>
            </div>
        </UiContainer>
        <UiContainer>
            <div class="cl-data">
                <div class="cl-data__row">
                    <div class="cl-data__left">
                        <div class="cl-data__left-item" />
                    </div>
                    <div class="cl-data__right">
                        <div class="cl-data__chart-header">
                            <p class="cl-data__chart-header-label">
                                {{ blok?.chart_1_title }}
                            </p>
                            <ul>
                                <li>
                                    <span class=" bg-chsc-indigo-500" />
                                    <span>Yes</span>
                                </li>
                                <li>
                                    <span class="bg-chsc-yellow" />
                                    <span>No</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="cl-data__row">
                    <div class="cl-data__left">
                        <div class="cl-data__description">
                            <StoryblokRichText :doc="blok?.chart_1_description" />
                        </div>
                    </div>
                    <div class="cl-data__right">
                        <ClientOnly>
                            <apex-charts
                                v-if="blok"
                                type="bar"
                                width="100%"
                                height="300"
                                :options="
                                    {
                                        chart: {
                                            type: 'bar',
                                            stacked: true,
                                            stackType: '100%',
                                            toolbar: {
                                                show: false,
                                            },
                                        },
                                        colors: ['#360086', '#FFC14A'],
                                        stroke: {
                                            show: false,
                                        },
                                        legend: {
                                            show: false,
                                        },
                                        dataLabels: {
                                            enabled: true,
                                        },
                                        tooltip: {
                                            enabled: false,
                                        },
                                        plotOptions: {
                                            bar: {
                                                horizontal: true,
                                                barHeight: '50px',
                                            },
                                        },
                                        xaxis: {
                                            categories: [2026, 2025, 2024, 2023],
                                        },
                                    }"
                                :series="[{
                                    name: 'yes',
                                    data: [Number(blok?.chart_1_2026), Number(blok?.chart_1_2025), Number(blok?.chart_1_2024), Number(blok?.chart_1_2023)],
                                }, {

                                    name: 'no',
                                    data: [100 - Number(blok?.chart_1_2026), 100 - Number(blok?.chart_1_2025), 100 - Number(blok?.chart_1_2024), 100 - Number(blok?.chart_1_2023)],

                                }]"
                            />
                        </ClientOnly>
                    </div>
                </div>
                <div class="cl-data__row">
                    <div class="cl-data__left" />
                    <div class="cl-data__right">
                        <div class="cl-data__resume">
                            <StoryblokRichText :doc="blok?.chart_1_resume" />
                        </div>
                    </div>
                </div>
            </div>
        </UiContainer>
        <!-- <UiContainer class="mt-32">
            <div class="cl-data">
                <div class="cl-data__row">
                    <div class="cl-data__left">
                        <div class="cl-data__left-item" />
                    </div>
                    <div class="cl-data__right">
                        <div class="cl-data__chart-header">
                            <p class="cl-data__chart-header-label">
                                {{ blok?.chart_2_title }}
                            </p>
                            <ul>
                                <li>
                                    <span class=" bg-chsc-indigo-500" />
                                    <span>Yes</span>
                                </li>
                                <li>
                                    <span class="bg-chsc-yellow" />
                                    <span>No</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="cl-data__row">
                    <div class="cl-data__left">
                        <div class="cl-data__description">
                            <StoryblokRichText :doc="blok?.chart_2_description" />
                        </div>
                    </div>
                    <div class="cl-data__right">
                        <ClientOnly>
                            <apex-charts
                                v-if="blok"
                                type="bar"
                                width="100%"
                                height="300"
                                :options="
                                    {
                                        chart: {
                                            type: 'bar',
                                            stacked: true,
                                            stackType: '100%',
                                            toolbar: {
                                                show: false,
                                            },
                                        },
                                        colors: ['#360086', '#FFC14A'],
                                        stroke: {
                                            show: false,
                                        },
                                        legend: {
                                            show: false,
                                        },
                                        dataLabels: {
                                            enabled: true,
                                        },
                                        tooltip: {
                                            enabled: false,
                                        },
                                        plotOptions: {
                                            bar: {
                                                horizontal: true,
                                                barHeight: '50px',
                                            },
                                        },
                                        xaxis: {
                                            categories: [2025, 2024],
                                        },
                                    }"
                                :series="[{
                                    name: 'yes',
                                    data: [Number(blok?.chart_2_2025), Number(blok?.chart_2_2024)],
                                }, {

                                    name: 'no',
                                    data: [100 - Number(blok?.chart_2_2025), 100 - Number(blok?.chart_2_2024)],

                                }]"
                            />
                        </ClientOnly>
                    </div>
                </div>
                <div class="cl-data__row">
                    <div class="cl-data__left" />
                    <div class="cl-data__right">
                        <div class="cl-data__resume">
                            <StoryblokRichText :doc="blok?.chart_2_resume" />
                        </div>
                    </div>
                </div>
            </div>
        </UiContainer> -->
    </section>
</template>
